"use client";
import type { PartnershipType } from "./data";

export default function PressTabs({
  active,
  onChange,
}: {
  active: PartnershipType;
  // eslint-disable-next-line no-unused-vars
  onChange: (_key: PartnershipType) => void;
}) {
  return (
    <div className="w-full lg:max-w-[825px] max-w-full lg:h-[68px] lg:rounded-[88px] rounded-[10px] p-1.5 bg-[#ecf0f6] mx-auto">
      <div className="flex lg:flex-row flex-col h-full gap-0">
        <button
          type="button"
          onClick={() => onChange("associate")}
          aria-label="Associate Partnership"
          className={`flex-1 h-full lg:rounded-[68px] rounded-[10px] px-10 py-2 text-[18px] font-semibold cursor-pointer transition-all ${
            active === "associate"
              ? "bg-white text-[#00040b]"
              : "text-[#00040b] bg-transparent"
          }`}
        >
          Associate Partnership
        </button>

        <button
          type="button"
          onClick={() => onChange("strategic")}
          aria-label="Strategic Partnership"
          className={`flex-1 h-full lg:rounded-[68px] rounded-[10px] px-10 py-2 text-[18px] font-semibold cursor-pointer transition-all ${
            active === "strategic"
              ? "bg-white text-[#00040b]"
              : "text-[#00040b] bg-transparent"
          }`}
        >
          Strategic Partnership
        </button>

        <button
          type="button"
          onClick={() => onChange("referral")}
          aria-label="Referral Partnership"
          className={`flex-1 h-full lg:rounded-[68px] rounded-[10px] px-10 py-2 text-[18px] font-semibold cursor-pointer transition-all ${
            active === "referral"
              ? "bg-white text-[#00040b]"
              : "text-[#00040b] bg-transparent"
          }`}
        >
          Referral Partnership
        </button>
      </div>
    </div>
  );
}
